module.exports = __webpack_public_path__ + "static/img/bg-ClientHover-01.21b8a6c4.png";